var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivileges(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 244.35,
    height: 266.46,
    viewBox: "0 0 244.35 266.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-1.5 0.03)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 244.35,
    height: 266,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M226,69.8a21,21,0,1,1-21-21.1A21.08,21.08,0,0,1,226,69.8Z",
    transform: "translate(-1.5 0.03)",
    fill: "#fff",
    stroke: "#71c4ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,52.7a16.8,16.8,0,1,0,16.7,16.8A16.75,16.75,0,0,0,205,52.7Zm0,30.8a14,14,0,1,1,14-14A14,14,0,0,1,205,83.5Z",
    transform: "translate(-1.5 0.03)",
    fill: "#71c4ef",
    stroke: "#71c4ef",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,63.5a7.08,7.08,0,0,0-4.5-1.3h-5.9V73.5h-2.2v2.1h2.2v1.7h2.2V75.6h4.6V73.5h-4.6V72.2h3.7a6.71,6.71,0,0,0,4.5-1.3,4.58,4.58,0,0,0,1.7-3.8A4.2,4.2,0,0,0,211,63.5Zm-1.6,6.1a4.37,4.37,0,0,1-2.9.9h-3.7V64h3.7a5.1,5.1,0,0,1,3,.8,2.78,2.78,0,0,1,1.1,2.4A3.49,3.49,0,0,1,209.4,69.6Z",
    transform: "translate(-1.5 0.03)",
    fill: "#71c4ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.8,264.6H65.4a16.9,16.9,0,0,1-16.9-17V18.8a16.9,16.9,0,0,1,16.9-17H180a16.9,16.9,0,0,1,16.9,17V247.6A17.2,17.2,0,0,1,179.8,264.6Z",
    transform: "translate(-1.5 0.03)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4,254.1a6.47,6.47,0,0,1-6.4-6.5V18.8a6.53,6.53,0,0,1,6.4-6.5H180a6.47,6.47,0,0,1,6.4,6.5V247.6a6.53,6.53,0,0,1-6.4,6.5Z",
    transform: "translate(-1.5 0.03)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4,248.9a1.32,1.32,0,0,1-1.3-1.3V18.8a1.32,1.32,0,0,1,1.3-1.3H180a1.32,1.32,0,0,1,1.3,1.3V247.6a1.32,1.32,0,0,1-1.3,1.3Z",
    transform: "translate(-1.5 0.03)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.9,108.2a11.27,11.27,0,0,0,14.2,7.4,11.32,11.32,0,0,0,0-21.6,22.51,22.51,0,0,0,.9-3.5l.6-3.6a5.67,5.67,0,0,0-4.6-6.5c-.3,0-.6-.1-.9-.1H157a5.76,5.76,0,0,0-5.5,4.3l-1.1,4.5L149,87.7a1.66,1.66,0,0,1-.5-1.3,7.36,7.36,0,0,0-2.1-5.1L145.1,80A8.45,8.45,0,0,0,133,80a8.54,8.54,0,0,0,0,12.1l1.3,1.3a6.94,6.94,0,0,0,5.1,2.1,1.9,1.9,0,0,1,1.3.5l1.4,1.4-4.5,1.1a5.68,5.68,0,0,0-4.3,5.5v.1a5.68,5.68,0,0,0,5.6,5.7,2.77,2.77,0,0,0,.9-.1l3.6-.6A20,20,0,0,0,146.9,108.2Zm18.3-3.4a7.53,7.53,0,0,1-14.8,2,22.64,22.64,0,0,0,9.2-9.2A7.22,7.22,0,0,1,165.2,104.8Zm-26-13.3a3.49,3.49,0,0,1-2.4-1l-1.3-1.3a4.81,4.81,0,0,1,6.8-6.8l1.3,1.3a3.1,3.1,0,0,1,1,2.4,5.76,5.76,0,0,0,1.6,4l2.5,2.5a10.71,10.71,0,0,1-3,3l-2.5-2.5A6,6,0,0,0,139.2,91.5Zm-.1,14.4a1.9,1.9,0,0,1-2.2-1.6v-.4a1.83,1.83,0,0,1,1.4-1.8l4.5-1.1a15.16,15.16,0,0,0,11-11l1.1-4.6a1.81,1.81,0,0,1,1.8-1.4h.1a2,2,0,0,1,1.9,1.9v.3l-.6,3.6a18.68,18.68,0,0,1-15.5,15.5Z",
    transform: "translate(-1.5 0.03)",
    fill: "#71c4ef",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,36.9H196.7",
    transform: "translate(-1.5 0.03)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,228.1H196.7",
    transform: "translate(-1.5 0.03)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2,241.7H137",
    transform: "translate(-1.5 0.03)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8,70.5V50.4A2.22,2.22,0,0,1,26,48.2H52a2.22,2.22,0,0,1,2.2,2.2V70.6H74.3a2.22,2.22,0,0,1,2.2,2.2V99a2.22,2.22,0,0,1-2.2,2.2H54.2v20.2a2.22,2.22,0,0,1-2.2,2.2H26a2.22,2.22,0,0,1-2.2-2.2V101.2H3.7A2.22,2.22,0,0,1,1.5,99V72.7a2.22,2.22,0,0,1,2.2-2.2Z",
    transform: "translate(-1.5 0.03)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,71.8V53.2a2,2,0,0,1,2-2H51a2,2,0,0,1,2,2V71.8H71.5a2,2,0,0,1,2,2V97.9a2,2,0,0,1-2,2H53v18.6a2,2,0,0,1-2,2H27a2,2,0,0,1-2-2V99.9H6.5a2,2,0,0,1-2-2V73.8a2,2,0,0,1,2-2Zm3.7-16.9H49.4V75.5H69.9V96.3H49.4v20.6H28.7V96.2H8.2V75.4H28.7Z",
    transform: "translate(-1.5 0.03)",
    fill: "#71c4ef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,69.3V50.2a2,2,0,0,1,2-2h29a2,2,0,0,1,2,2V69.3h19a2,2,0,0,1,2,2v29.1a2,2,0,0,1-2,2h-19v19.1a2,2,0,0,1-2,2h-29a2,2,0,0,1-2-2V102.4H3.5a2,2,0,0,1-2-2V71.3a2,2,0,0,1,2-2Zm2-19.7h29a.65.65,0,0,1,.6.6V70.7H74.5a.65.65,0,0,1,.6.6v29.1a.65.65,0,0,1-.6.6H54.1v20.4a.65.65,0,0,1-.6.6h-29a.65.65,0,0,1-.6-.6V101H3.5a.65.65,0,0,1-.6-.6V71.3a.65.65,0,0,1,.6-.6H23.9V50.2A.58.58,0,0,1,24.5,49.6Z",
    transform: "translate(-1.5 0.03)",
    fill: "#71c4ef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,69.3V50.2a2,2,0,0,1,2-2h29a2,2,0,0,1,2,2V69.3h19a2,2,0,0,1,2,2v29.1a2,2,0,0,1-2,2h-19v19.1a2,2,0,0,1-2,2h-29a2,2,0,0,1-2-2V102.4H3.5a2,2,0,0,1-2-2V71.3a2,2,0,0,1,2-2Zm2-19.7h29a.65.65,0,0,1,.6.6V70.7H74.5a.65.65,0,0,1,.6.6v29.2a.65.65,0,0,1-.6.6H54.1v20.4a.65.65,0,0,1-.6.6h-29a.65.65,0,0,1-.6-.6V101H3.5a.65.65,0,0,1-.6-.6V71.3a.65.65,0,0,1,.6-.6H23.9V50.2A.58.58,0,0,1,24.5,49.6Z",
    transform: "translate(-1.5 0.03)",
    fill: "#71c4ef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.6,174.6A1.6,1.6,0,1,1,142,173,1.64,1.64,0,0,1,143.6,174.6Z",
    transform: "translate(-1.5 0.03)",
    fill: "#71c4ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.3,154.2a8,8,0,0,0-8-8h-5.2l-7-19a4.45,4.45,0,0,0-2.5-2.7,4.76,4.76,0,0,0-3.7-.1L98.7,137.8a4.74,4.74,0,0,0-2.8,6.1l.9,2.3H89.5a8,8,0,0,0-8,8V195a8,8,0,0,0,8,8h63.8a8,8,0,0,0,8-8Zm-16.6-7.9H119.5l22.2-8.2Zm-45.8-4.7a1.42,1.42,0,0,1,.9-.8L136,127.4a1.09,1.09,0,0,1,.5-.1,2.54,2.54,0,0,1,.7.2,1.42,1.42,0,0,1,.8.9l.3.9L99.1,143.8l-.3-.9A2.77,2.77,0,0,1,98.9,141.6Zm40.6-9.3.8,2.3c.1.2.2.3.3.5l-30.4,11.2h-8.6Zm13.8,67.5H89.5a4.8,4.8,0,0,1-4.8-4.8V154.2a4.8,4.8,0,0,1,4.8-4.8h63.8a4.8,4.8,0,0,1,4.8,4.8v12.2h-2.6v-8.8a4.69,4.69,0,0,0-4.7-4.7H92.2a4.69,4.69,0,0,0-4.7,4.7v34.3a4.69,4.69,0,0,0,4.7,4.7h58.7a4.69,4.69,0,0,0,4.7-4.7v-9.1h2.6V195a5,5,0,0,1-4.9,4.8Zm.8-17v9.1a3.33,3.33,0,0,1-3.3,3.3H92.2a3.33,3.33,0,0,1-3.3-3.3V157.6a3.33,3.33,0,0,1,3.3-3.3h58.7a3.33,3.33,0,0,1,3.3,3.3v8.8H142.3a8.2,8.2,0,0,0,0,16.4Zm1.4-3.2h2.6v-10h-2.6Zm0-10v10H142.2a5,5,0,0,1-5-5,5,5,0,0,1,5-5Z",
    transform: "translate(-1.5 0.03)",
    fill: "#71c4ef",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivileges);
export default __webpack_public_path__ + "static/media/privileges.bd2b6f78.svg";
export { ForwardRef as ReactComponent };